module.exports = __webpack_public_path__ + "static-portal/img/006.894c4ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/006.jpg
// module id = Znr3
// module chunks = 4